import React, { useEffect, useState, useRef } from 'react';
import { motion } from 'framer-motion';
import '../styles/CustomerSupport.css';

const CustomerSupport = () => {
  const ref = useRef(null);
  const [isInView, setIsInView] = useState(false);

  // Scroll detection to check if the element is in view
  useEffect(() => {
    const handleScroll = () => {
      if (ref.current) {
        const rect = ref.current.getBoundingClientRect();
        const windowHeight = window.innerHeight;

        if (rect.top <= windowHeight * 0.8) {
          setIsInView(true);
        }
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <section ref={ref} className="customer-support">
      {/* Background Image */}
      <motion.div
        className="customer-bg"
        style={{
          backgroundImage: 'url("support.webp")',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      />

      {/* Foreground Overlay */}
      <div className="customer-overlay"></div>

      <motion.div
        className={`content-cus ${isInView ? 'animate-left' : ''}`}
      >
        <h1>Customer Support</h1>
        <p>
        Connect with <span>MAHADEV BOOK CUSTOMER SUPPORT</span> for Queries, Emergencies, Feedback, or Complaints. We're Available 24/7 to Assist You with Our Dedicated Online Services.
        </p>
        <hr className="customer-divider" />
        <div className="contact-number">
          <p>Customer Support No. For WhatsApp & Calling</p>
          <a href={`https://wa.me/918949471009`} className="phone-button">+44 7418 375763</a>
        </div>
      </motion.div>

      <div className="logo-section">
        <img src="lightLogo.gif" alt="Mahadev Book Logo" className="cus-img" />
        <img src="cards.gif" alt="Mahadev Book Logo" className="cus-card" />
        <p className="service-text">24 HOURS SERVICE</p>
      </div>
    </section>
  );
};

export default CustomerSupport;
